import { cn } from '@nesso/ui/lib/utils';

function TableRowSkeleton({ className, ...props }: React.ComponentProps<'div'>) {
    return (
        <div
            data-slot="table-row-skeleton"
            className={cn(
                'w-full border-b my-[14px] h-6 bg-muted animate-pulse rounded',
                className,
            )}
            {...props}
        />
    );
}

export { TableRowSkeleton };
